const CONTROLLED_PROPS = [
    'disabled',
    'onBlur',
    'onChange',
    'onFocus',
    'onMouseDown',
    'readOnly',
    'value'
];
const defaultFormatChars = {
    9: /[0-9]/,
    a: /[A-Za-z]/,
    '*': /[A-Za-z0-9А-Яа-я]/,
    я: /[А-Яа-я]/
};
export { CONTROLLED_PROPS, defaultFormatChars };
